export default "__VITE_ASSET__Bd217RVk__"